var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.asLink)?_c('a',{class:_vm.linkClasses,on:{"click":_vm.performGet}},[_vm._v(_vm._s(_vm.linkText))]):_c('div',{attrs:{"id":"passthrough-container"}})])}
var staticRenderFns = []

export { render, staticRenderFns }